/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoPlace
 */
export interface OutputGeoPlace {
    /**
     * район (для розрізнення однойменних НП)
     * @type {string}
     * @memberof OutputGeoPlace
     */
    county?: string;
    /**
     * тип НП: city|town|village|hamlet (для підпису м./с.)
     * @type {string}
     * @memberof OutputGeoPlace
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoPlace
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoPlace
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoPlace
     */
    lng?: number;
    /**
     * область
     * @type {string}
     * @memberof OutputGeoPlace
     */
    region?: string;
}

/**
 * Check if a given object implements the OutputGeoPlace interface.
 */
export function instanceOfOutputGeoPlace(value: object): boolean {
    return true;
}

export function OutputGeoPlaceFromJSON(json: any): OutputGeoPlace {
    return OutputGeoPlaceFromJSONTyped(json, false);
}

export function OutputGeoPlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoPlace {
    if (json == null) {
        return json;
    }
    return {
        
        'county': json['county'] == null ? undefined : json['county'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function OutputGeoPlaceToJSON(value?: OutputGeoPlace | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'county': value['county'],
        'kind': value['kind'],
        'label': value['label'],
        'lat': value['lat'],
        'lng': value['lng'],
        'region': value['region'],
    };
}

